import React from "react";
import logo from "assets/svg/logo.svg";

export default function Loader() {
  return (
    <div className="h-[70vh] flex justify-center  items-center  pulseWrapper">
      <div className="customPulse  flex justify-center items-center">
        <img src={logo} alt="Page loading " />
      </div>
    </div>
  );
}
